import { Input, TableProps } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import BackIcon from "../../../../assets/icons/BackIcon";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  AllShiftParams,
  GetShiftMembersResponse,
} from "../../../../features/organization/contractual/ShiftManagement/shiftManagement.type";
import { useGetShiftMembersQuery } from "../../../../features/organization/contractual/ShiftManagement/shiftManagementApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate } from "../../../../lib/time";
import { countParPageSerialNumber } from "../../../../utils/number";
import { valueOrNa } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";

export default function ShiftEmployeesView() {
  const navigate = useNavigate();
  const { id } = useParams();
  const {
    page,
    limit,
    filter,
    keyword,
    handleLimit,
    handleSearch,
    handleFilter,
    handlePagination,
  } = useTable<AllShiftParams>();

  // --- Query ---
  const { data, isLoading, isFetching, isError, error } =
    useGetShiftMembersQuery({
      id: id ? Number(id) : 0,
      args: {
        params: {
          search: keyword,
          ...filter,
          page,
          limit,
        },
      },
    });

  console.log("Shift Members Data: ", data);

  // --- Error Handling ---
  useError(isError, error, "Failed to fetch shift members");

  // --- Columns ---
  const columnWidth = 160;
  const columns: TableProps<GetShiftMembersResponse>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Bondhu Name",
      dataIndex: "name",
      width: columnWidth,
      render: (val) => valueOrNa(val),
    },
    {
      title: "Bondhu ID",
      dataIndex: "employee_id",
      width: columnWidth,
      render: (val) => valueOrNa(val),
    },
    {
      title: "Job Title",
      dataIndex: "job_title",
      width: columnWidth,
      render: (val) => valueOrNa(val),
    },
    {
      align: "center",
      title: "Joining Date",
      dataIndex: "joining_date",
      width: columnWidth,
      render: (val) => formatDate(val),
    },
  ];

  return (
    <>
      <SidebarLayout title="Shifts">
        <div className="flex items-center gap-3 mb-6">
          <button onClick={() => navigate(-1)}>
            <BackIcon />
          </button>

          <h2 className="text-2xl font-semibold">Shift Employee List</h2>
        </div>

        <CustomTable
          loading={isLoading || isFetching}
          limit={limit}
          page={page}
          columns={columns}
          total={data?.data?.total || 0}
          dataSource={addKeyInArray(data?.data?.members || [])}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                size="middle"
                suffix={<SearchIcon />}
                placeholder="Search"
                style={{ minWidth: 170, maxWidth: 180 }}
                onChange={(val) => handleSearch(val)}
                allowClear
              />
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}
